import React,{useState,useEffect} from 'react';
import "./Results.scss";

function Results(){

    const [results,set_results] = useState([])

    useEffect(()=>{
        getResults()
    },[])

    const goTo = async (url)=>{
        window.open(url, "_blank")
    }

    const getResults = async ()=>{
        let url = "https://www.parsehlab.com/wp-content/uploads/%D9%81%D8%B1%D9%85-%D9%88%D8%A7%DA%A9%D8%B3%D9%86.pdf"
        try{
            // const res = await getResults();
            set_results([
                {uid:1,title:"آزمایش شماره یک",date:"1401-07-21",description:"",status:"در انتظار",url:url},
                {uid:2,title:"آزمایش شماره دو",date:"1401-07-13",description:"",status:"مشاهده جواب",url:url},
                {uid:3,title:"آزمایش شماره سه",date:"1401-07-02",description:"",status:"مشاهده جواب",url:url},
                {uid:4,title:"آزمایش شماره چهار",date:"1401-06-18",description:"",status:"مشاهده جواب",url:url},
                {uid:5,title:"آزمایش شماره پنج",date:"1401-06-14",description:"",status:"مشاهده جواب",url:url},
                {uid:6,title:"آزمایش شماره شش",date:"1401-05-10",description:"",status:"مشاهده جواب",url:url},
                {uid:7,title:"آزمایش شماره هفت",date:"1401-04-28",description:"",status:"مشاهده جواب",url:url},
                {uid:8,title:"آزمایش شماره هشت",date:"1401-04-20",description:"",status:"مشاهده جواب",url:url},
                {uid:9,title:"آزمایش شماره نه",date:"1401-03-02",description:"",status:"مشاهده جواب",url:url},
                {uid:10,title:"آزمایش شماره ده",date:"1401-02-17",description:"",status:"مشاهده جواب",url:url},
            ])
        }catch(e){
            console.error(e)
        }
    }

    return(
        <div className="results-container">
            <div className="results-container-header">
                <img src="https://dlslab.com/wp-content/uploads/2020/12/covid-19-testing-centers-scaled.jpg" alt=""/>
            </div>
            <div className="results-list">
                {results.map(r=>{
                    return(
                        <div className="results-item">
                            <div className="results-item-status">
                                <span onClick={e=>{
                                    goTo(r.url)
                                }} className={r.status==="در انتظار"?"results-pending":"results-completed"}>{r.status}</span>
                            </div>
                            <div className="results-item-title">
                                <span>{r.title}</span>
                                <span className="results-item-date">{r.date}</span>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default Results;
